module.exports = __webpack_public_path__ + "img/news.e41faa40.svg";